<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <!-- SIDEBAR -->
    <fuse-sidebar class="sidebar" name="service-main-sidebar" position="left" lockedOpen="gt-md">
        <service-main-sidebar (filteredCategory)="filterByCategory($event)"></service-main-sidebar>
    </fuse-sidebar>
    <!-- / SIDEBAR -->

    <!-- CENTER -->
    <div class="center">

        <div class="content-card" style="overflow-y: scroll;">
            <!-- CONTENT -->
            <div id="ngx-datatable" class="page-layout simple fullwidth docs">
                <div class="content p-24">
                    <input
                            autofocus
                            type="text"
                            style="padding:8px;margin:15px auto;width:30%;"
                            placeholder="{{ 'Type to filter services list...'|translate }}"
                            (input)="updateFilter($event)"
                    />

                    <ngx-datatable
                        #table
                        class="material"
                        [rows]="rows"
                        [loadingIndicator]="loadingIndicator"
                        [columnMode]="'force'"
                        [headerHeight]="48"
                        [footerHeight]="56"
                        [rowHeight]="'auto'"
                        [scrollbarH]="true"
                        [reorderable]="reorderable"
                        [selectionType]="'checkbox'"
                        [externalPaging]="true"
                        [count]="page.totalElements"
                        [offset]="page.pageNumber"
                        [limit]="page.size"
                        (page)="setPage($event)"
                        (sort)="sortResults($event)"
                    >

                        <ngx-datatable-column [width]="48"
                                              [canAutoResize]="false"
                                              [sortable]="false">
                            <ng-template ngx-datatable-header-template let-value="value" let-allRowsSelected="allRowsSelected"
                                         let-selectFn="selectFn">
                            </ng-template>

                            <ng-template ngx-datatable-cell-template let-value="value" let-isSelected="isSelected"
                                         let-onCheckboxChangeFn="onCheckboxChangeFn">

                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="{{'Name'|translate}}" sortable="true" prop="id">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>

                                <a routerLink="/services/details/{{row.id}}">{{row.name}}</a>

                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'Category'|translate}}" prop="category.name"></ngx-datatable-column>
                        <ngx-datatable-column name="{{'Type'|translate}}" prop="type">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{row.type|translate}}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'Required time'|translate}}" prop="requiredTime"></ngx-datatable-column>
                        <ngx-datatable-column name="{{'Price gross'|translate}}" prop="priceGross"></ngx-datatable-column>
                        <ngx-datatable-column name="{{'Vat rate'|translate}}" prop="vatRate.vatName"></ngx-datatable-column>
                        <ngx-datatable-column name="{{'Actions'|translate}}" sortable="true" prop="id">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                <a routerLink="/services/edit/{{row.id}}">{{'Edit'|translate}}</a>

                                <button
                                        mat-button
                                        class="mr-8"
                                        aria-label="Delete"
                                        color="warn"
                                        (click)="showConfirmServiceDeleteDialog(row)"
                                >
                                    {{'Delete'|translate}}
                                </button>
                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </div>
            </div>
        </div>
    </div>
</div>
